/**
 * Auto-generated TypeScript types from OpenAPI specification
 * 
 * Title: App Template API
 * Version: 1.0.0
 * 
 * DO NOT EDIT THIS FILE DIRECTLY
 */

import axios, { type AxiosInstance } from 'axios';
import { getNeonAuthAccessToken, isNeonAuthEnabled } from '@/utils/auth.utils';

export const apiClient: AxiosInstance = axios.create({
  baseURL: '/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Request interceptor to attach Neon Auth access token
apiClient.interceptors.request.use(
  async config => {
    // Only add token if Neon Auth is enabled
    if (isNeonAuthEnabled) {
      console.log('[apiClient] Neon Auth enabled, fetching token...');
      const token = await getNeonAuthAccessToken();
      if (token) {
        config.headers['x-stack-access-token'] = token;
        console.log('[apiClient] Token attached to request:', config.url);
      } else {
        console.warn('[apiClient] No token available for request:', config.url);
      }
    }
    return config;
  },
  error => {
    console.error('[apiClient] Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      console.error(
        '[apiClient] 401 Unauthorized:',
        error.config?.url,
        error.response?.data
      );
      if (isNeonAuthEnabled) {
        const currentPath = window.location.pathname;
        // Avoid redirect loops for auth pages
        if (!currentPath.startsWith('/handler/')) {
          console.log('[apiClient] Redirecting to sign-in page');
          window.location.href = '/handler/sign-in';
        }
      }
    }
    return Promise.reject(error);
  }
);
